import React, { Component } from 'react';
import 'antd/dist/reset.css';
import { withRouter } from '../../Components/Items'


class Politicas extends Component {

    render() {
        return (
            <div className='registro-carrera-backgorund'>
                <div className="registro-carrera-container">
                    <h1 className="registro-carrera-title">Política de Privacidad</h1>
                    <div className="registro-carrera-form">
                        <p>
                            <strong>En INTEGRAME DOWN AC, valoramos la privacidad de nuestros usuarios y estamos comprometidos a proteger la información personal que recopilamos a través de nuestro sitio web www.todossomosdiferentes.com. Esta Política de Privacidad describe cómo recopilamos, utilizamos y protegemos su información.</strong>
                        </p>
                        <p>
                            <strong>1. Información que Recopilamos</strong><br />
                            Durante el proceso de registro y uso de nuestro sitio web, podemos recopilar la siguiente información:
                        </p>
                        <ul>
                            <li><strong>Datos personales:</strong> Nombre, correo electrónico, número de teléfono, fecha de nacimiento y dirección.</li>
                            <li><strong>Información de pago:</strong> Datos relacionados con los métodos de pago utilizados para la inscripción, incluyendo detalles procesados por nuestro proveedor de pagos, Conekta.</li>
                            <li><strong>Información de uso:</strong> Datos relacionados con la navegación en el sitio web, como direcciones IP, tipo de dispositivo y navegador.</li>
                        </ul>
                        <p>
                            <strong>2. Uso de la Información</strong><br />
                            La información recopilada se utilizará para:
                        </p>
                        <ul>
                            <li>Procesar y gestionar su registro en la carrera.</li>
                            <li>Confirmar pagos y emitir comprobantes.</li>
                            <li>Enviar comunicaciones relacionadas con el evento.</li>
                            <li>Mejorar la experiencia del usuario en nuestro sitio web.</li>
                            <li>Cumplir con obligaciones legales.</li>
                        </ul>
                        <p>
                            <strong>3. Procesamiento de Pagos</strong><br />
                            Los pagos realizados con tarjeta de crédito o débito son procesados de manera segura a través de nuestro proveedor de servicios de pago, Conekta. INTEGRAME DOWN AC no almacena información confidencial de tarjetas en sus sistemas. Para más información sobre el manejo de datos por parte de Conekta, le recomendamos consultar su Política de Privacidad en el sitio web oficial de Conekta.
                        </p>
                        <p>
                            <strong>4. Compartición de Información</strong><br />
                            No compartimos información personal con terceros, salvo en los siguientes casos:
                        </p>
                        <ul>
                            <li>Con nuestro proveedor de pagos, Conekta, para procesar las transacciones de forma segura.</li>
                            <li>Cuando sea requerido por ley o por autoridades competentes.</li>
                        </ul>
                        <p>
                            <strong>5. Seguridad de la Información</strong><br />
                            Implementamos medidas de seguridad técnicas y organizativas para proteger su información contra acceso no autorizado, pérdida o alteración. Sin embargo, ningún sistema es completamente seguro, por lo que no podemos garantizar la seguridad absoluta de los datos transmitidos.
                        </p>
                        <p>
                            <strong>6. Derechos del Usuario</strong><br />
                            De acuerdo con la legislación vigente, usted tiene derecho a:
                        </p>
                        <ul>
                            <li>Acceder a sus datos personales y conocer cómo se están utilizando.</li>
                            <li>Solicitar la rectificación de datos incorrectos o incompletos.</li>
                            <li>Pedir la eliminación de sus datos personales cuando sea posible.</li>
                            <li>Revocar su consentimiento para el tratamiento de sus datos personales.</li>
                        </ul>
                        <p>
                            Para ejercer estos derechos, puede comunicarse con nosotros a través del correo electrónico contacto@todossomosdiferentes.com.
                        </p>
                        <p>
                            <strong>7. Cookies y Tecnologías Similares</strong><br />
                            Nuestro sitio web utiliza cookies para mejorar su experiencia de navegación. Usted puede configurar su navegador para rechazar las cookies, aunque esto podría afectar el funcionamiento de ciertas funcionalidades del sitio.
                        </p>
                        <p>
                            <strong>8. Cambios en la Política de Privacidad</strong><br />
                            Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier momento. Las modificaciones se publicarán en esta página con la fecha de última actualización. Recomendamos revisarla periódicamente.
                        </p>
                        <p>
                            <strong>9. Contacto</strong><br />
                            Si tiene preguntas o inquietudes sobre esta Política de Privacidad, puede comunicarse con nosotros en:
                        </p>
                        <ul>
                            <li><strong>Correo electrónico:</strong> contacto@todossomosdiferentes.com</li>
                        </ul>
                        <p>
                            <strong>Última actualización:</strong> 9 de enero de 2025
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Politicas);